import { Icon, Text, XStack, YStack } from '@frontend/web-react';
import type { IconName } from '@frontend/web-react/components/Primitives/Icon/helpers';

type SectionCardProps = {
  children?: React.ReactNode;
  icon?: IconName;
  isLoading?: boolean;
  onPressEdit?: () => void;
  title: string;
};

export const SectionCard = ({ children, icon, isLoading, onPressEdit, title }: SectionCardProps) => {
  return (
    <YStack
      bg="trueWhite"
      borderColor="borderPrimary"
      borderWidth={1}
      className="shadow-one"
      gapY="sm"
      p="md"
      radius="lg"
    >
      <XStack alignItems="center" className="gap-sm" justifyContent="between">
        <XStack gapX="xs">
          {icon ? <Icon name={icon} /> : null}
          <YStack className="gap-y-xs">
            <Text type="h4">{title}</Text>
          </YStack>
        </XStack>
        {onPressEdit ? (
          <Icon
            accessibilityLabel={`Edit ${title.toLowerCase()}`}
            isLoading={isLoading}
            name="IconPencil"
            onClick={onPressEdit}
            size={14}
          />
        ) : null}
      </XStack>
      <YStack>{children}</YStack>
    </YStack>
  );
};
